import React, {useEffect, useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import {Box, Button, CssBaseline, Grid} from '@mui/material';
import {data} from "./csvjson";
import SustainabilityTableHeader from './SustainabilityTableHeader';
import SustainabilityTableRow from './SustainabilityTableRow';
import SustainabilityTablePagination from './SustainabilityTablePagination';
import FilterControls from './FilterControls';
import {styled} from '@mui/system';
import DownloadIcon from '@mui/icons-material/Download';
import {downloadButtonStyle} from "./styles";
import Papa from 'papaparse';
import {Analytics} from '@vercel/analytics/react';
import {ComposableMap, Geographies, Geography, Sphere, ZoomableGroup} from "react-simple-maps"


const StyledPaper = styled(Paper)({
  borderRadius: '15px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
  border: '1px solid #f0f0f0',
  padding: '2rem'
});


export default function SustainabilityTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [cloudProviderQuery, setCloudProviderQuery] = useState('AWS');
  const uniqueRegionNames = new Set(data.map(row => row.AWS_Region));
  const uniqueContinentNames = new Set(data.map((row) => row.Continent_Name));
    data.sort((a, b) => {
        return (a.fossil_fuel_percentage - b.fossil_fuel_percentage) !== 0 ? (a.fossil_fuel_percentage - b.fossil_fuel_percentage) : (a.carbon_intensity - b.carbon_intensity)
    })
  const updateFilteredData = () => {
    const filtered = data
        .filter(row =>
            (cloudProviderQuery === "AWS" ? row.AWS_Region !== "" :
                cloudProviderQuery === "Azure" ? row.Azure_Region !== "" :
                    row.GCP_Region !== "")
        )
        .filter(row => row.carbon_intensity !== 0)
        .filter(row => row.Continent_Name === continentFilter);

    filtered.sort((a, b) =>
        (a.fossil_fuel_percentage - b.fossil_fuel_percentage) !== 0 ?
            (a.fossil_fuel_percentage - b.fossil_fuel_percentage) :
            (a.carbon_intensity - b.carbon_intensity)
    );

    setFilteredData(filtered);
    setPage(0);
  };
  const [filteredData, setFilteredData] = useState(data);
  const [regionFilter, setRegionFilter] = useState('us-east-1');
  const [continentFilter, setContinentFilter] = useState('Europe');
  function handleDownload() {
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'filtered_data.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  useEffect(() => {
    updateFilteredData();
  }, [regionFilter, cloudProviderQuery, continentFilter]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  const geoUrl =
      "https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json"


  return (
    <React.Fragment>
      <Analytics />
      <CssBaseline />

      <Grid container direction="column" spacing={2} style={{ padding: '20px 40px' }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ padding: '20px 40px' }}>
            <Grid item xs={12} sm={9}>
              <FilterControls
                uniqueRegionNames={uniqueRegionNames}
                uniqueContinentNames={uniqueContinentNames}
                regionFilter={regionFilter}
                setRegionFilter={setRegionFilter}
                cloudProviderQuery={cloudProviderQuery}
                setCloudProviderQuery={setCloudProviderQuery}
                continentFilter={continentFilter}
                setContinentFilter={setContinentFilter}
              />
            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'right' }}>
              <Button
                  variant="contained"
                  color="primary"
                  startIcon={<DownloadIcon />}
                  onClick={handleDownload}
                  sx={downloadButtonStyle}
                      >
                Report
              </Button>
            </Grid>
          </Grid>
          <Grid>
            <Box>
              <TableContainer component={StyledPaper}>
                <Table sx={{ minWidth: 650,  border: '2px solid lightgray' }} aria-label="simple table">
                  <SustainabilityTableHeader />
                  <TableBody>
                    {paginatedData.map((row) => (
                      <SustainabilityTableRow
                          row={row}
                          cloudProviderQuery={cloudProviderQuery} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <SustainabilityTablePagination
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Grid>
      {/*<ComposableMap projection="geoMercator" style={{ width: '100%', height: 'auto' }}>*/}
      {/*    <Sphere fill="#a5d8ff" />*/}
      {/*    <Geographies geography={geoUrl}>*/}
      {/*      {({ geographies }) =>*/}
      {/*          geographies.map((geo) => (*/}
      {/*              <Geography key={geo.rsmKey} geography={geo} stroke="#846358"*/}
      {/*                         style={{*/}
      {/*                           default: {*/}
      {/*                             fill: "#a18072",*/}
      {/*                             outline: 'none',*/}
      {/*                             transition: 'fill 0.2s',*/}
      {/*                             strokeWidth: 0.5,*/}
      {/*                             strokeDasharray: "2,2",*/}
      {/*                           },*/}
      {/*                           hover: {*/}
      {/*                             fill: "#2f9e44",*/}
      {/*                             outline: 'none',*/}
      {/*                             transition: 'fill 0.2s',*/}
      {/*                           },*/}
      {/*                           pressed: {*/}
      {/*                             fill: "#22ee92",*/}
      {/*                             outline: 'none',*/}
      {/*                             transition: 'fill 0.2s',*/}
      {/*                           },*/}
      {/*                         }}*/}
      {/*              />*/}
      {/*          ))*/}
      {/*      }*/}
      {/*    </Geographies>*/}
      {/*</ComposableMap>*/}
    </React.Fragment>
  );
}
